import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { User } from '@integrado/contracts';
import { api } from '@/lib/api';
export const useAuthStore=defineStore('auth',()=>{
  const user=ref<User|null>(null);const ready=ref(false);
  async function load(){try{user.value=(await api<{user:User|null}>('/auth/session')).user;}finally{ready.value=true;}}
  async function login(username:string,password:string){user.value=(await api<{user:User}>('/auth/login',{method:'POST',body:JSON.stringify({username,password})})).user;ready.value=true;}
  async function logout(){await api('/auth/logout',{method:'POST'});user.value=null;}
  return {user,ready,load,login,logout};
});
